import React from "react";
import AdminDashboardLayout from "../layout/AdminDashboardLayout";
import { Typography } from "@mui/material";



export default function AdminDashboard() {
    return (
    <>
        
        <AdminDashboardLayout>
            <Typography>Welcome to dashboard</Typography>
        </AdminDashboardLayout>
        </>
    
    )
}